export default __webpack_public_path__ + "static/media/worm.862845a4.png";